module.exports = __webpack_public_path__ + "static/img/111.dbb2e6d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/2/111.png
// module id = dxxq
// module chunks = 0